import React from 'react';
import { connect } from 'react-redux';
import { openOrderCancelDialog, openOrderJournalDetailDialog, openOrderModifyDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { REFRESH_DATA } from '@/constants/app';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '@/components/DataTable/DataTable';
import { checkSessionAction } from '@/actions/auth'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';
import '@/assets/styles/commons/_styles.scss'


let IntervalRef;
class OrderBook extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.defaultColumnDefs= () => [
      {
        headerName: this.props.language.common_actions,
        colId: 'common_actions',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell',
        dataType: dataType.EDIT_CANCEL,
        cellRendererParams: {
          onEditOrder: this.handleEditOrder,
          onCancelOrder: this.handleCancelOrder,
        },
        sortable: false,
        minWidth: 60,
        maxWidth: 80
      },
      {
        headerName: this.props.language.common_order_id,
        colId: 'common_order_id',
        field: 'orderGroupID',
        tooltipField: 'orderGroupID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        cellRendererParams: {
          action: this.handleViewOrderDetail
        },
        minWidth: 85,
        maxWidth: 200

      },
      {
        headerName: this.props.language.common_symbol,
        colId: 'common_symbol',
        field: 'instrumentID',
        tooltipField: 'instrumentID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        cellRendererParams: {
          market: 'marketID',
          instrument: 'instrumentID'
        },
        minWidth: 160,
        maxWidth: 230
      },
      {
        headerName: this.props.language.common_name,
        colId: 'common_name',
        field: 'instrumentName',
        tooltipField: 'instrumentName',
        headerClass: 'table-header',
        cellClass: 'table-cell table-ellipsis',
        dataType: dataType.TEXT,
        cellRendererParams: {
          stockName: 'instrumentName',
          chineseStockName: 'instrumentChineseName',
          cellClass: 'table-cell table-ellipsis',
        },
        minWidth:260,
        maxWidth:400
      },
      {
        headerName: this.props.language.common_ccy,
        colId: 'common_ccy',
        field: 'currencyID',
        tooltipField: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth: 50,
        maxWidth:100
      },
      {
        headerName: this.props.language.common_buy_sell,
        colId: 'common_buy_sell',
        field: 'bs',
        tooltipField: 'bs',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell text-center',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 60,
        maxWidth: 120
      },
      {
        headerName: this.props.language.common_price,
        colId: 'common_price',
        field: 'price',
        tooltipField: 'price',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.CURRENCY,
        minWidth: 60,
        maxWidth:160
      },
      {
        headerName: this.props.language.common_quantity,
        colId: 'common_quantity',
        field: 'qty',
        tooltipField: 'qty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth:90,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_filled_qty,
        colId: 'common_filled_quantity',
        field: 'filledQty',
        tooltipField: 'filledQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth: 90,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_outstanding_quantity,
        colId: 'common_outstanding_quantity',
        field: 'osQty',
        tooltipField: 'osQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.NUMBER,
        minWidth: 100,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_avg_price,
        colId: 'common_avg_price',
        field: 'avgPrice',
        tooltipField: 'avgPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.AVG_PRICE,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_status,
        colId: 'common_status',
        field: 'status',
        tooltipField: 'status',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 100,
        maxWidth:140
      },
      {
        headerName: this.props.language.common_order_type,
        colId: 'common_order_type',
        field: 'orderType',
        tooltipField: 'orderType',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 135,
        maxWidth: 200
      },
      {
        headerName: this.props.language.common_stop_price,
        colId: 'common_stop_price',
        field: 'stopPrice',
        tooltipField: 'stopPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.CURRENCY,
        minWidth: 90,
        maxWidth: 160
      },
      {
        headerName: this.props.language.common_create_time,
        colId: 'common_create_time',
        field: 'inputTime',
        tooltipField: 'inputTime',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.LONG_DATE,
        minWidth: 130,
        maxWidth: 240
      }
    ]
    this.fundColumnDefs= () => [
      {
        headerName: this.props.language.common_actions,
        colId: 'funds_common_actions',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell',
        dataType: dataType.EDIT_CANCEL,
        cellRendererParams: {
          onEditOrder: this.handleEditOrder,
          onCancelOrder: this.handleCancelOrder,
        },
        sortable: false,
        minWidth: 60,
        maxWidth: 80
      },
      {
        headerName: this.props.language.common_order_id,
        colId: 'funds_common_order_id',
        field: 'orderID',
        tooltipField: 'orderID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        cellRendererParams: {
          action: this.handleViewOrderDetail
        },
        minWidth: 80,
        maxWidth: 200
      },
      {
        headerName: this.props.language.common_funds_market_id,
        colId: 'funds_common_market_id',
        field: 'marketID',
        tooltipField: 'marketID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 80,
        maxWidth:120
      },
      {
        headerName: this.props.language.funds_instrument_id,
        colId: 'funds_instrument_id',
        field: 'instrumentID',
        tooltipField: 'instrumentID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 160,
        maxWidth: 230
      },
      {
        headerName: this.props.language.funds_instrument_name,
        colId: 'funds_instrument_name',
        field: 'instrumentName',
        tooltipField: 'instrumentName',
        headerClass: 'table-header',
        cellClass: 'table-cell table-ellipsis',
        dataType: dataType.TEXT,
        minWidth:380,
      },
      {
        headerName: this.props.language.common_ccy,
        colId: 'funds_common_ccy',
        field: 'currencyID',
        tooltipField: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth: 50,
        maxWidth:100
      },
      {
        headerName: this.props.language.common_buy_sell,
        colId: 'funds_buy_sell',
        field: 'bs',
        tooltipField: 'bs',
        headerClass: 'table-header text-center',
        cellClass: 'table-cell text-center',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 80,
        maxWidth: 100
      },
      {
        headerName: this.props.language.common_price,
        colId: 'funds_price',
        field: 'price',
        tooltipField: 'price',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell  text-right',
        dataType: dataType.CURRENCY,
        minWidth: 60,
        maxWidth:160
      },
      {
        headerName: this.props.language.common_quantity,
        colId: 'funds_quantity',
        field: 'qty',
        tooltipField: 'qty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth:114,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_filled_qty,
        colId: 'funds_filled_quantity',
        field: 'filledQty',
        tooltipField: 'filledQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_outstanding_quantity,
        colId: 'funds_outstanding_quantity',
        field: 'osQty',
        tooltipField: 'osQty',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.FUNDS_QUANTITY,
        minWidth: 120,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_avg_price,
        colId: 'funds_avg_price',
        field: 'avgPrice',
        tooltipField: 'avgPrice',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-right',
        dataType: dataType.AVG_PRICE,
        minWidth: 85,
        maxWidth:170
      },
      {
        headerName: this.props.language.common_status,
        colId: 'funds_status',
        field: 'status',
        tooltipField: 'status',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.ORDER_CELL_RENDER,
        minWidth: 100,
        maxWidth:140
      },
      // {
      //   headerName: this.props.language.common_order_type,
      //   colId: 'funds_order_type',
      //   field: 'orderType',
      //   headerClass: 'table-header',
      //   cellClass: 'table-cell',
      //   dataType: dataType.ORDER_CELL_RENDER,
      //   minWidth: 135,
      //   maxWidth: 200
      // },
      // {
      //   headerName: this.props.language.common_stop_price,
      //   colId: 'funds_stop_price',
      //   field: 'stopPrice',
      //   headerClass: 'table-header text-end',
      //   cellClass: 'table-cell',
      //   dataType: dataType.CURRENCY,
      //   minWidth: 90,
      //   maxWidth: 160
      // },
      {
        headerName: this.props.language.common_create_time,
        colId: 'funds_create_time',
        field: 'inputTime',
        tooltipField: 'inputTime',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.LONG_DATE,
        minWidth: 130,
        maxWidth: 240
      }
    ]
    this.state = {
      data: null,
      status:'',
      marketID:'',
      columnDefs: this.defaultColumnDefs()
    }
  }
  render() {
    const { data, columnDefs } = this.state;
    return (
      <div className="order-book-container" style={{ flexGrow: 1 }}>
        <DataTable
          name={TABLE_CONFIGURABLE_KEYS.TRADE_PORTFOLIO_ORDER_BOOK}
          innerRef={e => this.tableRef = e}
          columnDefs={columnDefs}
          data={data}
          autoSizeColumns={true} />
      </div>
    )
  }

  handleEditOrder = (order) => {
    openOrderModifyDialog(order);
  }

  handleCancelOrder = (order) => {
    openOrderCancelDialog(order);
  }

  handleViewOrderDetail = (order) => {
    openOrderJournalDetailDialog(order, null, false, true, false);
  }

  getData(status = '', refreshSession = false ,marketID = '') {
    const { currentTradingAccount, token, language } = this.props
    this.setState({
      // data:[],
      status:status,
      marketID:marketID,
      
    })
    
    if (currentTradingAccount.clientID && token) {
      if (this.tableRef && refreshSession) {
        this.tableRef.toggleLoadingOverlay(true);
      }
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: status,
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID
      }
      if(refreshSession === false){
        params.refreshSession = refreshSession
      }

      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ 
              data: res.result.orderInfoList,
              columnDefs: marketID == "FUND" ? this.fundColumnDefs() : this.defaultColumnDefs()
            });
            this.props.toggleRefreshTable(false)
          } else {
            this.setState({
              data: []
            })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  componentDidUpdate(prevProps) {
    // const { currentTradingAccount } = this.props
    // if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
    //   if(JSON.stringify(prevProps.currentTradingAccount) !== "{}"){
    //     this.getData()
    //   }
    // }
    // if (this.props.token && this.props.token !== prevProps.token) {
    //   this.getData();
    // }
    // if (this.props.language && this.props.language !== prevProps.language) {
    //   // this.getData();
    // }
  }

  componentDidMount() {
    const refreshTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshTime ?? 0;
    // this.getData();
    if(refreshTime !== 0){
      const refreshSession = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.refreshSession ?? true;
      const checkSessionTime = iTradeEnv?.pages?.trade?.orderEnquiry?.autoRefresh?.checkSessionTime ?? 300000;
      IntervalRef = setInterval(() => {
        this.props.checkSession('',res=>{}, error=>{
          if(SERVICES_RESP.SESSION_TIMEOUT.includes(error.result.errorCode))
          clearInterval(IntervalRef)
        })
      }, checkSessionTime);
      IntervalRef = setInterval(() => {
        if(this.props.stopQutoRefresh === 'true'){
          clearInterval(IntervalRef)
        } else {
          this.getData(this.state.status,refreshSession);
        }
      }, refreshTime);
    }
  }

  componentWillUnmount() {
    IntervalRef && clearInterval(IntervalRef)
  }
}

OrderBook.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    token: state.auth.token,
    stopQutoRefresh: state.trade.stopQutoRefresh
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c)),
    checkSession: (p, c, b) => dispatch(checkSessionAction(p, c, b)),
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.ORDER_TABLE,
      value: p
    })
  })
)(OrderBook)
